module.exports = __webpack_public_path__ + "img/blue_127.13802dd2.png";